var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook-app-symbol",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5 -3 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M40.312,8.966V4.876h1.372l.206-1.594H40.312V2.265c0-.461.128-.776.79-.776h.843V.062A11.437,11.437,0,0,0,40.716,0a1.92,1.92,0,0,0-2.05,2.107V3.282H37.29V4.876h1.376v4.09Z",
    transform: "translate(-37.29)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ec375035d76a105ca33b427a63802c5c.svg";
export { ForwardRef as ReactComponent };